// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".confirm-popover {\n  z-index: 1;\n}\n.confirm-popover.tooltip .popover-inner {\n  background-color: var(--v-primary-base);\n  box-shadow: 0 0 10px black;\n  line-height: 22px;\n  padding: 10px 0px;\n  border-radius: var(--default-radius);\n  pointer-events: initial !important;\n}\n@media (max-width: 768px) {\n.avatar-popover {\n    width: 75%;\n}\n.avatar-popover .tooltip-inner {\n    max-width: initial !important;\n}\n}", ""]);
// Exports
module.exports = exports;
